export default __webpack_public_path__ + "images/menu.svg?ff2c2ead5063f66d7affdd1bf6832407";